var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup8699(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.16,
    height: 19.844,
    viewBox: "0 0 33.16 19.844",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-14134.888 3380.402)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9381.478,9.3c.493-3.432,2.37-3.52,3.159-5.3-10.165,1.35-13.29,15.677-5.37,19.154a7.353,7.353,0,0,0,10.254-5.1C9390.625,12.773,9386.535,9.053,9381.478,9.3Z",
    transform: "translate(4778.346 -3384.395)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.23,5.3a5.634,5.634,0,0,1,1.136-2.85,14.333,14.333,0,0,1,1.5-1.57c.487-.6.226-.187.53-.877A12.231,12.231,0,0,0,1.2,7.595c-1.854,4.938.267,10.127,3.978,11.641a7.344,7.344,0,0,0,10.158-5.516c.855-5.17-3.173-8.579-8.107-8.421Z",
    transform: "translate(14134.369 -3380.402)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup8699);
export default __webpack_public_path__ + "static/media/Group 8699.5a9cd787a069126da85cee499d546795.svg";
export { ForwardRef as ReactComponent };